<div class="lead-time">
    <h-message-block
        [autoAddPadding]="false"
        [hasIcon]="false"
        [showBackground]="showBackground"
        [type]="'info'"
        class="block-input">
        <ng-container>{{ leadTimeInformation$ | async }}</ng-container>
    </h-message-block>
</div>
